export const surveyChartTooltips = {
  IHA: "Internal ($t(data.acquired.default.IHA))",
  IHAw: "Internal worsening ($t(data.acquired.default.IHAw))",
  POA: "External ($t(data.acquired.default.POA))",
  PIHAw: "External - worsening internally ($t(data.acquired.default.PIHAw))"
};
